// The ad click a call, a lead or a job came from (BL-092, AdTrack's click details): the platform, the
// campaign, the keyword and its match type, the page they landed on and the click's id, closed to a line
// until opened. Kept by the company's website tag, or imported from AdTrack. Nothing shows when there's
// no click, or the office can't read it.

import { useEffect, useState } from 'react';
import { client } from '../api.ts';
import { clickLine, clickRows, type AdClick } from './ad-click-model.ts';
import './ad-click.css';

type Of = { callId: string } | { leadId: string } | { jobId: string };

export function AdClickDetails({ click, timeZone }: { click: AdClick; timeZone?: string }) {
  const when = (iso: string) =>
    new Intl.DateTimeFormat('en-CA', { timeZone, dateStyle: 'medium', timeStyle: 'short' }).format(
      new Date(iso),
    );
  return (
    <details className="ad-click">
      <summary>From an ad: {clickLine(click)}</summary>
      <dl className="kv">
        {clickRows(click, when).map(([k, v]) => (
          <div key={k} className="ad-click-row">
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
    </details>
  );
}

/** The click of one call, lead or job, read when it shows. */
export function AdClickOf({ of, timeZone }: { of: Of; timeZone?: string }) {
  const [click, setClick] = useState<AdClick | null>(null);
  const key = JSON.stringify(of);
  useEffect(() => {
    let live = true;
    setClick(null);
    client
      .call<{ click: AdClick | null }>('adClicks.get', JSON.parse(key) as Of)
      .then((r) => live && setClick(r.click))
      // a click is extra: with none to read, the record shows as it did
      .catch(() => live && setClick(null));
    return () => {
      live = false;
    };
  }, [key]);
  return click ? <AdClickDetails click={click} timeZone={timeZone} /> : null;
}
